export const basicFormData = () => ({
  inputData: {
    gst_percentage: "",
    is_active: true,
    created_by: 1,
    updated_by: 1,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "gst_masters",
  };

  const navigatePage = { back: "/gstpercentage-list" };

  const headerName = "GST Percentage";

  const validationType = "GSTPercentageCreate";
  const createEndpoint = "/saveGST";
  const updateEndpoint = "/saveGST";
  const getEndpoint = "/getGST";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "gst_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "GST Percentage", value: "gst_percentage" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/gstpercentage-create",
    edit: "/gstpercentage-create",
  };

  const searchfields = [
    "role_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "GST Percentage";
  const endpoint = "/getGST";
  const exportFileName = "gstpercentageData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "gst_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
